import type {LogLevel} from './types';

const LEVELS: LogLevel[] = ['trace', 'debug', 'info', 'warn', 'error', 'silent'];

let threshold = LEVELS.indexOf('warn');

const shouldLog = (level: number): boolean => threshold <= level;

const log = {
    trace: (...args: unknown[]): void => {
        if (shouldLog(0)) console.trace(...args);
    },
    debug: (...args: unknown[]): void => {
        if (shouldLog(1)) console.debug(...args);
    },
    info: (...args: unknown[]): void => {
        if (shouldLog(2)) console.info(...args);
    },
    warn: (...args: unknown[]): void => {
        if (shouldLog(3)) console.warn(...args);
    },
    error: (...args: unknown[]): void => {
        if (shouldLog(4)) console.error(...args);
    },
    setLevel: (level: LogLevel): void => {
        threshold = LEVELS.indexOf(level);
    },
};

const isDev = import.meta.env.MODE === 'dev' || import.meta.env.MODE === 'development';

log.setLevel(isDev ? 'trace' : 'warn');

export default log;
